import { render, staticRenderFns } from "./Post_Portfolio_Component.vue?vue&type=template&id=65d5d88c&scoped=true"
import script from "./Post_Portfolio_Component.vue?vue&type=script&lang=js"
export * from "./Post_Portfolio_Component.vue?vue&type=script&lang=js"
import style0 from "./Post_Portfolio_Component.vue?vue&type=style&index=0&id=65d5d88c&prod&scoped=true&lang=css"
import style1 from "./Post_Portfolio_Component.vue?vue&type=style&index=1&id=65d5d88c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d5d88c",
  null
  
)

export default component.exports